<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-40">
    <!--      volver button for mobile -->
    <section class="ml-[31px] block  sm:hidden">
      <button (click)="goHome()" class="mt-[21px] mb-[13px]">
        <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
      </button>
    </section>

    <section
      class="border-t-opacity-10 border-t-[1.8px] border-t-beige sm:border-b-beige sm:border-b-opacity-10 sm:border-b-[1.8px]  bg-blanco bg-opacity-10 sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]">
      <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
      <div class="mx-[36px] sm:mx-[120px]">
        <!-- top components -->
        <!--      volver button-->
        <section class="hidden sm:block">
          <button (click)="goHome()" class="mt-[15px] mb-[14px] flex items-center transition duration-100 hover:scale-110">
            <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
            <span class="font-['Roboto'] text-base font-normal text-cafe ml-[6px]">{{'buttons.goHome' | transloco}}</span>
          </button>
        </section>
      </div>
      </div>
    </section>
    <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
    <div class="flex flex-col mx-[36px] sm:mx-[120px] pt-[25px] pb-[52px] min-h-[600px]">
      <ln-all-special-created-products></ln-all-special-created-products>
    </div>
    <div class="flex sm:mx-[68px] items-center  border-b-[2px] opacity-40 border-b-verde"></div>
    </div>
  </section>
</ln-ln-pages-armor>

